import TenantCommunication from './TenantTracker.vue';

export default TenantCommunication;
